import randomize from 'randomatic'
import zxcvbn from 'zxcvbn'

export function generate (length, complexity) {
  var complexityPattern = ''
  complexityPattern += complexity[0] ? 'A' : ''
  complexityPattern += complexity[1] ? 'a' : ''
  complexityPattern += complexity[2] ? '0' : ''
  complexityPattern += complexity[3] ? '!' : ''

  return randomize(complexityPattern || '*', length || 15)
}

export function check (password) {
  var result = zxcvbn(password.slice(0, password.length - 1))
  return result.score
}
/* Result scores:
  0 - veryWeak
  1 - weak
  2 - mediocre
  3 - strong
  4 - veryStrong
*/



// WEBPACK FOOTER //
// ./src/password-generator.js